import React, { useContext, useEffect, useState } from "react";
import ContentLayout from "../../component/ContentLayout";
import { AgGridReact } from "ag-grid-react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import axios from "../../util/axios";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import UserModal from "../../component/UserModal";
import { Context } from "../../component/Context/ErrorContext";
import { Switch, Modal, Box, Checkbox, FormControlLabel, FormControl, Button } from "@mui/material";
import { VscLoading } from "react-icons/vsc";

const Driver = () => {
  const { setError } = useContext(Context);
  const navigate = useNavigate();
  const [userData, setUserData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchBy, setSearchBy] = useState("name");
  const [searchByText, setSearchByText] = useState("");
  const [createUserModal, setCreateUserModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [isPermanentDelete, setIsPermanentDelete] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [user, setUser] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "+1",
    gender: "Male",
    city: "",
    registered: "",
    state: "",
    zip: "",
    userreferrallink: "",
    middlename: "",
    refferalcode: "",
    ipin: "",
    userreferenceid: "",
    dob: "",
  });
  const [driversData, setDriversData] = useState<any>(null);
  // Column Definitions: Defines the columns to be displayed.
  const [colDefs] = useState<any>([
    // {
    //   field: "active",
    //   headerName: "Status",
    //   cellRenderer: (param: any) => {
    //     return (
    //       <div className={"w-full h-full"}>
    //         <Switch checked={param?.data?.is_deleted ? false : param?.data?.active}  onChange={() => DeleteUserHandler(param?.data?.id)}/>
    //       </div>
    //     );
    //   },
    //   minWidth: 80,
    //   maxWidth: 80,
    //   cellClass: "flex justify-center items-center",
    // },
    {
      field: "is_deleted",
      headerName: "Status",
      minWidth: 50,
      cellRenderer: (param: any) => {
        return (
            <div
                className={"flex items-center justify-center"}
            >
              <Switch
                  checked={!param?.value}
                  // disabled
                  // onChange={() => userDisableHandler(param?.data)}
                  onChange={() => DeleteUserHandler(param?.data?.id, !param?.data?.is_deleted)}
              />
            </div>
        );
      },
    },
    {
      field: "fullname",
      headerName: "Name",
      minWidth: 250,
      cellRenderer: (param: any) => {
        return (
          <div
            className={"flex items-center gap-2 cursor-pointer"}
            onClick={() => navigate(`/drivers/${param?.data?.id}`)}
          >
            <VisibilityIcon />
            <p>{param.value}</p>
          </div>
        );
      },
    },
    // { field: "created_by", headerName: "Created By" },
    {
      field: "created_dt",
      headerName: "Registered",
      minWidth: 100,
      cellRenderer: (param: any) => {
        return (
          <div className={"h-full flex flex-col items-center justify-center"}>
            <p className={"p-0 text-sm"}>
              {moment(param.value).format("MM-DD-yyyy")}
            </p>
            <p className={"p-0 text-sm font-bold"}>
              {moment(param.value).format("hh:mm A")}
            </p>
          </div>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 200,
      cellRenderer: (param: any) => {
        return (
          <div className={"flex items-center justify-start"}>
            <p>{param.value}</p>
          </div>
        );
      },
    },
    { field: "phone", headerName: "Phone", minWidth: 150 },
    {
      field: "referral_code",
      headerName: "Code",
      minWidth: 100,
      cellRenderer: (param: any) => {
        return (
          <div className={"flex items-center justify-center"}>
            <p>{param.value || "-"}</p>
          </div>
        );
      },
    },
    { field: "referral_count", headerName: "Count", minWidth: 80 },
    {
      field: "sex",
      headerName: "Sex",
      minWidth: 80,
      cellRenderer: (param: any) => {
        return (
          <div className={"flex items-center justify-center"}>
            <p>{param.value || "-"}</p>
          </div>
        );
      },
    },
    {
      field: "is_archie",
      headerName: "Archie",
      minWidth: 50,
      cellRenderer: (param: any) => {
        console.log("archie :",param.value);
        return (
            <div className={"flex items-center justify-center"}>
              <p>{param.value ? "true" : "false"} </p>
            </div>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 100,
      cellRenderer: (param: any) => {
        return (
          <div className={"flex items-center justify-center gap-2"}>
            <button
              onClick={() => {
                setSelectedUser(param.data);
                setDeleteModal(true);
                setIsPermanentDelete(false);
              }}
              className={
                "p-2 bg-red-500 text-white rounded-md hover:bg-red-600 flex items-center justify-center"
              }
              title="Delete User"
            >
              <DeleteIcon fontSize="small" />
            </button>
          </div>
        );
      },
    },
  ]);
  const getDriversData = async () => {
    axios({
      URL: "/omw/get-drivers-data",
      method: "GET",
    })
      .then((res) => {
        setDriversData(res?.data?.data);
      })
      .catch((err) => setError(err?.response?.data?.message));
  };

  useEffect(() => {
    fetchData(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber, pageSize]);

  useEffect(() => {
    getDriversData(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async (text?: string) => {
    setLoading(true);
    const url =
      searchBy && text
        ? `/omw/users?page_num=${pageNumber}&page_size=${pageSize}&${searchBy}=${text}`
        : `/omw/users?page_num=${pageNumber}&page_size=${pageSize}`;
    axios({
      URL: url,
      method: "GET",
    })
      .then((res: any) => {
        if (res.data) {
          setUserData(res.data.data.users);
          setTotalRecords(res.data.data.total);
        }
      })
      .catch((err) => setError(err?.response?.data?.message))
      .finally(() => setLoading(false));
  };

  const onPageChange = (action: string, step: number) => {
    if (action === "prev") {
      if (pageNumber - step > 0) {
        setPageNumber(pageNumber - step);
      } else {
        setPageNumber(1);
      }
    } else {
      const totalPages = Math.ceil(totalRecords / pageSize);
      if (pageNumber + step <= totalPages) {
        setPageNumber(pageNumber + step);
      } else {
        setPageNumber(totalPages);
      }
    }
  };
  const createUserHandler = () => {
    const data = {
      middle_name: user?.middlename,
      referral_code: user?.refferalcode,
      ipin: user?.ipin,
      user_reference_id: user?.userreferenceid,
      dob: user?.dob,
      gender: user?.gender,
      city: user?.city,
      state: user?.state,
      zipcode: user?.zip,
      user_referral_link: user?.userreferrallink,
      first_name: user?.firstname,
      last_name: user?.lastname,
      email: user?.email,
      phone: user?.phone,
    };
    axios({
      URL: "/omw/admin/create-user",
      method: "POST",
      data: data,
    })
      .then((res: any) => {
        if (res.data) {
          setUser({
            firstname: "",
            lastname: "",
            email: "",
            phone: "",
            gender: "",
            city: "",
            registered: "",
            state: "",
            zip: "",
            userreferrallink: "",
            middlename: "",
            refferalcode: "",
            ipin: "",
            userreferenceid: "",
            dob: "",
          });
          setCreateUserModal(false);
        }
      })
      .catch((err) => setError(err?.response?.data?.message));
  };

  const DeleteUserHandler = (id: any, is_delete:any) => {
    axios({
      URL: `/omw/deleteUser/${id}`,
      method: "POST",
      data: { mark:is_delete },
    })
      .then((res: any) => {
        if (res.data) {
          fetchData();
        }
      })
      .catch((err) => setError(err?.response?.data?.message));
  };

  const handleDeleteConfirm = async () => {
    if (!selectedUser) return;

    setDeleteLoading(true);
    
    try {
      // Delete API call with is_permanent flag
      await axios({
        URL: `/omw/admin/deleteUser/${selectedUser.id}`,
        method: "DELETE",
        data: { 
          is_permanent: isPermanentDelete
        },
      });

      setDeleteModal(false);
      setSelectedUser(null);
      setIsPermanentDelete(false);
      fetchData();
      getDriversData();
    } catch (err: any) {
      setError(err?.response?.data?.message || "Failed to delete user");
    } finally {
      setDeleteLoading(false);
    }
  };

  const userDisableHandler = async (data: any) => {
    console.log(data);
    await axios({
      URL: `/omw/admin/update-user/${data?.id}`,
      method: "PUT",
      data: { ...data, is_deleted: !data?.is_deleted },
    })
      .then((res: any) => {
        fetchData()
      })
      .catch((err) => setError(err?.response?.data?.message))
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <ContentLayout className={"items-start"}>
      <p className={"text-3xl font-bold text-secondary"}>Drivers</p>
      <div className={"mt-4 w-full h-auto bg-white p-2"}>
        <div
          className={
            "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 p-3"
          }
        >
          <div className={"flex flex-col bg-primary p-4 gap-1"}>
            <p className={"text-white text-2xl font-bold"}>
              {driversData?.user_count || 0}
            </p>
            <p className={"text-white"}>Total Users</p>
          </div>
          <div className={"flex flex-col bg-primary p-4 gap-1"}>
            <p className={"text-white text-2xl font-bold"}>
              {driversData?.total_earned || 0}
            </p>
            <p className={"text-white"}>Total Earned</p>
          </div>
          <div className={"flex flex-col bg-primary p-4 gap-1"}>
            <p className={"text-white text-2xl font-bold"}>
              {driversData?.monthly_active_users || 0}
            </p>
            <p className={"text-white"}>Monthly Active Users</p>
          </div>
          <div className={"flex flex-col bg-primary p-4 gap-1"}>
            <p className={"text-white text-2xl font-bold"}>
              {driversData?.daily_active_users || 0}
            </p>
            <p className={"text-white"}>Daily Active Users</p>
          </div>
          <div className={"flex flex-col bg-primary p-4 gap-1"}>
            <p className={"text-white text-2xl font-bold"}>
              {Math.round(driversData?.female_percentage * 100) / 100 || 0} %
            </p>
            <p className={"text-white"}>Female Users</p>
          </div>
          <div className={"flex flex-col bg-primary p-4 gap-1"}>
            <p className={"text-white text-2xl font-bold"}>
              {Math.round(driversData?.male_percentage * 100) / 100 || 0} %
            </p>
            <p className={"text-white"}>Male Users</p>
          </div>
          <div className={"flex flex-col bg-primary p-4 gap-1"}>
            <p className={"text-white text-2xl font-bold"}>
              {driversData?.referral_count || 0}
            </p>
            <p className={"text-white"}>Referral Count</p>
          </div>
          <div className={"flex flex-col bg-primary p-4 gap-1"}>
            <p className={"text-white text-2xl font-bold"}>
              {driversData?.distance_travelled || 0}
            </p>
            <p className={"text-white"}>Total Miles Driven</p>
          </div>
          <div className={"flex flex-col bg-primary p-4 gap-1"}>
            <p className={"text-white text-2xl font-bold"}>
              {driversData?.distance_travelled_today || 0}
            </p>
            <p className={"text-white"}>Miles Driven Daily</p>
          </div>
          <div className={"flex flex-col bg-primary p-4 gap-1"}>
            <p className={"text-white text-2xl font-bold"}>
              {driversData?.lives_saved || 0}
            </p>
            <p className={"text-white"}>Lives Saved</p>
          </div>
          <div className={"flex flex-col bg-primary p-4 gap-1"}>
            <p className={"text-white text-2xl font-bold"}>
              {driversData?.crashes_prevented || 0}
            </p>
            <p className={"text-white"}>Crashes Prevented</p>
          </div>
          {driversData?.state_with_max_users ? (
            <div className={"flex flex-col bg-primary p-4 gap-1"}>
              <p className={"text-white text-2xl font-bold"}>
                {driversData?.state_with_max_users?.user_count || 0}
              </p>
              <p className={"text-white"}>
                {driversData?.state_with_max_users?.state}
              </p>
            </div>
          ) : null}
        </div>
        <div className={"flex w-full justify-end my-3 px-3"}>
          <div
            className={
              "gap-2 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 md:w-auto w-full"
            }
          >
            <div className={"flex gap-1 justify-center items-center w-full"}>
              <label
                htmlFor="search"
                className={"text-primary whitespace-nowrap"}
              >
                Search By
              </label>
              <select
                name="search"
                id="search"
                className={`border border-primary text-primary border-solid py-2 w-full rounded-md`}
                value={searchBy}
                onChange={(e) => {
                  setSearchBy(e.target.value);
                }}
              >
                <option value={"name"}>Name</option>
                <option value={"email"}>Email</option>
                <option value={"phone"}>Phone</option>
                <option value={"referral_code"}>Referral Code</option>
              </select>
            </div>
            <input
              className={
                "border border-primary border-solid p-2 text-primary placeholder-primary w-full rounded-md"
              }
              placeholder={"Search Driver"}
              value={searchByText}
              onChange={(e) => setSearchByText(e.target.value)}
            />
            <div className={"flex flex-row gap-2"}>
              <button
                className={
                  "flex items-center justify-center bg-primary text-white px-8 py-2 rounded-md sm:w-auto w-full h-[43px] disabled:cursor-not-allowed"
                }
                onClick={() => (searchBy ? fetchData(searchByText) : null)}
                disabled={loading}
              >
                Search
              </button>
              <button
                className={
                  "flex items-center justify-center bg-primary text-white px-8 py-2 rounded-md sm:w-auto w-full h-[43px] whitespace-nowrap disabled:cursor-not-allowed"
                }
                onClick={() => {
                  setSearchByText("");
                  setSearchBy("");
                  setPageNumber(1);
                  fetchData();
                }}
                disabled={loading}
              >
                Clear All
              </button>
            </div>
          </div>
        </div>
        <div className={"flex w-full justify-end my-3 px-3"}>
          <button
            className={
              "flex items-center justify-center bg-primary text-white px-8 py-2 rounded-md sm:w-auto w-full"
            }
            onClick={() => setCreateUserModal(true)}
          >
            Create User
          </button>
        </div>
        <div className="ag-theme-quartz w-full" style={{ height: 500 }}>
          <AgGridReact
            loading={loading}
            rowData={userData}
            defaultColDef={{
              flex: 10,
            }}
            columnDefs={colDefs}
            // pagination={pagination}
            // paginationPageSize={pageSize}
            // paginationPageSizeSelector={paginationPageSizeSelector}
            suppressRowClickSelection={true}
            // onPaginationChanged={(event) => onPageChange(event)}
          />
        </div>
        <div
          className={
            "my-2 px-2 w-full flex justify-end flex-col sm:flex-row gap-4 sm:gap-10"
          }
        >
          <div>
            <label htmlFor="pages">Page size:</label>
            <select
              name="page"
              id="page"
              className={
                "w-[100px] border-b border-primary border-solid p-2 outline-none"
              }
              value={pageSize}
              onChange={(e) => {
                setPageNumber(1);
                setPageSize(+e.target.value);
              }}
            >
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
          </div>
          <div className={"flex gap-2 justify-center items-center"}>
            <KeyboardDoubleArrowLeftIcon
              className={"text-lg cursor-pointer"}
              onClick={() => (pageNumber < 2 ? null : onPageChange("prev", 2))}
            />
            <KeyboardArrowLeftIcon
              className={"text-lg cursor-pointer"}
              onClick={() =>
                pageNumber === 0 ? null : onPageChange("prev", 1)
              }
            />
            <p>
              Page {pageNumber} of {Math.ceil(totalRecords / pageSize)}
            </p>
            <KeyboardArrowRightIcon
              className={`text-lg cursor-pointer`}
              onClick={() =>
                pageNumber === Math.ceil(totalRecords / pageSize)
                  ? null
                  : onPageChange("next", 1)
              }
            />
            <KeyboardDoubleArrowRightIcon
              className={"text-lg cursor-pointer"}
              onClick={() =>
                pageNumber + 2 > Math.ceil(totalRecords / pageSize)
                  ? null
                  : onPageChange("next", 2)
              }
            />
          </div>
        </div>
      </div>
      <UserModal
        open={createUserModal}
        onClose={() => setCreateUserModal(false)}
        user={user}
        setUser={setUser}
        onSubmit={createUserHandler}
      />

      {/* Delete Modal */}
      <Modal open={deleteModal} onClose={() => !deleteLoading && setDeleteModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "10px",
          }}
        >
          <h2 className="text-2xl font-bold mb-4">Delete User</h2>
          <p className="mb-4 text-gray-600">
            Are you sure you want to delete <strong>{selectedUser?.fullname}</strong>?
          </p>
          
          <FormControl component="fieldset" className="mb-4 w-full">
            <FormControlLabel
              control={
                <Checkbox
                  checked={isPermanentDelete}
                  onChange={(e) => setIsPermanentDelete(e.target.checked)}
                  disabled={deleteLoading}
                />
              }
              label={
                <span className="text-sm font-medium">
                  Permanent Delete
                </span>
              }
            />
          </FormControl>

          <div className="flex gap-2 justify-end">
            <Button
              variant="outlined"
              onClick={() => {
                setDeleteModal(false);
                setSelectedUser(null);
                setIsPermanentDelete(false);
              }}
              disabled={deleteLoading}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleDeleteConfirm}
              disabled={deleteLoading}
              className="flex items-center gap-2"
            >
              {deleteLoading ? (
                <>
                  <VscLoading className="animate-spin" />
                  Deleting...
                </>
              ) : (
                "Delete"
              )}
            </Button>
          </div>
        </Box>
      </Modal>
    </ContentLayout>
  );
};

export default Driver;
